import React from 'react'
import Helmet from 'react-helmet'
import { config } from 'config'
import { rhythm } from '../utils/typography'
import { Link } from 'react-router'
import { prefixLink } from 'gatsby-helpers'
import Heading from '../components/Heading'
import TriRoundRow from '../components/TriRoundRow'
import CenterRow from '../components/CenterRow'
import Divider from '../components/Divider'
import CTAButton from '../components/CTAButton'
import Hero from '../components/Hero'
import LeadForm from '../components/LeadForm'
import AppsAndService from '../components/AppsAndService'

import '../css/applications.less'

class TechnicalPage extends React.Component {
  render () {
  	const pages = [ ...this.props.route.pages ]
    const path = this.props.route.page.path

  	const meta = {
  		description: "Technical Documentation for ACS acoustic cleaners (sonic horns)",
  		keywords: "Acoustic Cleaning Systems Tehcnial Docs",
  		headline: "ACS Technical Docs: We have your application covered.",
  		title: "ACS Technical Docs: We have your application covered."
  	}

		const docs = [
			{ name: "ACS Catalog Digital RevB", href: "/technical-docs/ACS Catalog Digital RevB.pdf" },
			{ name: "Maintenance and Operation Manual", href: "/technical-docs/Maintenance and Operation Manual.pdf" },
		]

		const docLinks = docs.map((doc) => {
			return (
				<div className="col-md-3 col-sm-6 col-xs-12">
					<p>
						<a target="_blank" className="technical-doc-link" href={doc.href}>{doc.name}</a>
					</p>
				</div>
			)
		})

    return (
      <div className="">
        <Helmet
          title={`${meta.title}`}
          meta={[
            { name: "Description", content: `${meta.description}`},
            { name: "Keywords", content: `${meta.keywords}`},
            { property: "og:title", content: `${meta.headline}`},
            { property: "og:description", content: `${meta.description}`},
            { property: "og:type", content: "article"},
            { property: "og:url", content: `${config.rootUrl}${path}`},
            { name: "twitter:card", content: "summary_large_image"},
            { name: "twitter:site", content: `${config.twitterHandle}` },
            { name: "twitter:creator", content: `${config.twitterHandle}` },
            { name: "twitter:title", content: `${meta.title}` },
            { name: "twitter:description", content: `${meta.description}` }
          ]}
        />
				<Hero headline='Our horns are a sound investment.'
					className="applications"
					images={[
						'/images/hero/1.jpg',
						'/images/hero/2.jpg',
						'/images/hero/0.jpg',
					]}
				>
					<LeadForm />
				</Hero>
				<div className="container page installations-page">
					<br /><br />
					<CenterRow headline="Technical Documentation">
						Here are some common technical docs available for you to download as you continue to research our product.
					</CenterRow>
					<Divider />
					<div className="current-clients">
						<div className="row center-xs">
							{docLinks}
						</div>
					</div>
					<Divider />
					<AppsAndService />
				</div>
    	</div>
    )
  }
}

TechnicalPage.propTypes = {}
TechnicalPage.defaultProps = {}
TechnicalPage.data = {
  menuLabel: 'Applications',
	excludeFromMenu: true,
  menuShortDescription: 'Technical Docs for Acoustic Cleaning Services, Inc.'
}
export default TechnicalPage



// WEBPACK FOOTER //
// ./technical.js